
import { Card } from "@/components/ui/card";
import { Car, Home, Building2, Heart, FileText } from "lucide-react";
import { Policy } from "@/components/admin/contact-details/sections/policy/types";

interface UserPolicyCardProps {
  policy: Policy;
}

export const UserPolicyCard = ({ policy }: UserPolicyCardProps) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  };

  const getIcon = (type: string) => {
    switch (type.toLowerCase()) {
      case 'auto':
      case 'auto insurance':
      case 'automobile':
      case 'car':
        return Car;
      case 'home':
      case 'homeowners':
      case 'home insurance':
      case 'renters':
        return Home;
      case 'business':
      case 'commercial':
        return Building2;
      case 'life':
      case 'life insurance':
        return Heart;
      default:
        console.log('Insurance type:', type); // Debug log
        return FileText;
    }
  };

  const Icon = getIcon(policy.insurance_type);

  return (
    <Card className="w-full p-6 bg-white border border-[#E5DEFF] hover:border-primary transition-colors">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="p-2 bg-[#F1F0FB] rounded-lg">
            <Icon className="h-6 w-6 text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-primary-dark">
              {policy.insurance_type}
            </h3>
            <div className="space-y-2 mt-2">
              <p className="text-sm text-neutral">
                Policy Number: <span className="text-primary-dark">{policy.policy_number}</span>
              </p>
              <p className="text-sm text-neutral">
                Status: <span className="text-primary-dark capitalize">{policy.status}</span>
              </p>
              <p className="text-sm text-neutral">
                Carrier: <span className="text-primary-dark">{policy.insurance_carrier || 'Not Specified'}</span>
              </p>
              <p className="text-sm text-neutral">
                Premium: <span className="text-primary-dark">${policy.premium_amount}</span>
              </p>
              <p className="text-sm text-neutral">
                Valid: <span className="text-primary-dark">
                  {formatDate(policy.start_date)} - {formatDate(policy.end_date)}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
